import React, { useState } from "react";
import "./Dnav.css"; // Import CSS file for styling
import Logo from "../atrimages/logo.jpg";
import "../Navbar/navbar.css";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo Navband">
        <NavLink to="/">
          <img src={Logo} alt="brandlogo" />
        </NavLink>
      </div>
      <button
        className={`navbar-toggle ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <ul className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
        <li className="navbar-item">
          <NavLink to="/">Home</NavLink>
        </li>
        <li className="navbar-item">
          <NavLink to="events">Events</NavLink>
          <ul>
            <li className="navbar-item">
              <NavLink to="events/clubevent">Club Events</NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to="events/committe">Committe Events</NavLink>
            </li>
          </ul>
        </li>
        <li className="navbar-item">
          <NavLink to="gallary">Gallary</NavLink>
        </li>
        <li className="navbar-item">
          <NavLink to="sponsors">Sponsors</NavLink>
        </li>
        <li className="navbar-item">
          <NavLink to="ourteam">OurTeam</NavLink>
        </li>
        <li className="navbar-item">
          <NavLink to="contact">Contact</NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
